function isWeChatWeb() {
	var ua = navigator.userAgent.toLowerCase();
  console.log(ua);
	var isWeixin = ua.indexOf('micromessenger') != -1;

	return isWeixin;
}

export default isWeChatWeb();
